import React from "react";
import { Link } from "react-router-dom";
import { gql, useQuery, useMutation } from "@apollo/client";
import { Form } from "react-final-form";
import { TextField } from "@syos-music/form";

import { Grid, Button, Container } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import Layout from "components/common/Layout";
import GmailGrant from "components/user/GmailGrant";
import signatureTemplate from "components/user/signatureTemplate";

const getQuery = () => gql`
  query {
    user {
      id

      profile {
        job
        phone
      }

      ...GmailGrant_user
      ...signatureTemplate_user
    }
  }

  ${GmailGrant.fragments.user}
  ${signatureTemplate.fragments.user}
`;

const MUTATION = gql`
  mutation ($userId: ID!, $profile: UpdateUser_Profile!) {
    UpdateUser(userId: $userId, profile: $profile) {
      user {
        id

        profile {
          job
          phone
        }
      }
    }
  }
`;

export default function ProfilePage() {
  // Avoir circular dep
  const { data, loading } = useQuery(React.useMemo(getQuery, []));
  const [updateUser] = useMutation(MUTATION);

  if (loading) return <Layout.Loading />;
  if (!data?.user) return <Layout.NotFound />;

  const user = data.user;

  return (
    <Container fixed sx={{ p: 2 }}>
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <GmailGrant user={data.user} />
        </Grid>

        <Grid item xs={6}>
          <div dangerouslySetInnerHTML={{ __html: signatureTemplate(user) }} />
        </Grid>

        <Grid item xs={6}>
          <Form
            onSubmit={({ job, phone }) =>
              updateUser({
                variables: {
                  userId: user.id,
                  profile: { job, phone },
                },
              })
                .then(() => {})
                .catch(() => true)
            }
            initialValues={{
              job: user.profile.job,
              phone: user.profile.phone,
            }}
          >
            {({ handleSubmit, pristine, invalid, submitting, form }) => (
              <form onSubmit={handleSubmit} noValidate autoComplete="off">
                <Grid container justifyContent="flex-end">
                  <Grid item xs={12}>
                    <TextField name="job" label="Fonction" />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      name="phone"
                      label="Téléphone"
                      placeholder="+33 6 00 00 00 00"
                    />
                  </Grid>

                  <Grid item>
                    <LoadingButton
                      type="submit"
                      disabled={pristine}
                      loading={submitting}
                    >
                      Enregistrer
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Form>
        </Grid>

        <Grid item xs={12}>
          <Button component={Link} to="/user/logout">
            Déconnexion
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
